<template>
  <el-footer
    height="42px"
    class="footer-el-outbox"
  >
    <div class="footer-box">
      <div>
        <span>友情链接:</span>
        <a
          href="http://www.samr.gov.cn/"
          target="_blank"
        >国家市场监督管理总局</a>
        <a
          href="http://scjgj.sc.gov.cn/"
          target="_blank"
        >四川省市场监督管理局</a>
        <a
          href="http://kjt.sc.gov.cn/"
          target="_blank"
        >四川省科学技术厅</a>
      </div>
    </div>
  </el-footer>
</template>

<script>
export default {
  name: 'PageFooter',
};
</script>

<style scoped lang="less">
    .footer-el-outbox{
        background:rgba(225,225,225,1);
        display: flex;
        align-items: center;
        .footer-box{
            width: 100%;
            margin: auto;
            font-size:14px;
            font-weight:500;
            color:rgba(145,145,145,1);
            a {
              margin: 0 20px;
              text-decoration: none;
              color: inherit;
            }
        }
    }
</style>
